import Component from "@ember/component"
import { action, set } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type { CardStandard } from "@shared/models/card-stack"
import type { AiValueEditor } from "cc-frontend/lib/ai/ai-value-editor"
import type StandardsModalService from "cc-frontend/services/standards-modal"
import SortableNode from "ember-sortable/mixins/sortable-node"
import {
  completeSorting,
  hideSectionValues,
  showSectionValues,
  startSorting,
} from "../../../../../lib/section-moving"

// @ts-ignore
export default class Standards
  extends Component.extend(SortableNode)
  implements AiValueEditor<CardStandard[]>
{
  handle = ".js-move-button"

  @service("ember-store") store

  @service dragging

  @service lessonEditor

  @service declare standardsModal: StandardsModalService

  registerCardEditor?: (cardId: string, prop: string, editor: AiValueEditor<unknown>) => void

  hideSectionValues = hideSectionValues
  showSectionValues = showSectionValues
  startSorting = startSorting
  completeSorting = completeSorting

  hoveringTimer

  state = {
    isHovering: false,
    allowSectionActionAnimation: false,
    hasEntered: false,
    isAiEditing: false,
  }
  aiStandards: CardStandard[] = []

  didInsertElement() {
    this.registerCardEditor?.(this.section.id, "standards", this)
  }

  canReceiveSortable(_node) {
    return false
  }

  mouseEnter() {
    if (this.hoveringTimer) clearTimeout(this.hoveringTimer)
    if (this.dragging.isDragging) return
    if (this.state.hasEntered === false) set(this.state, "hasEntered", true)
    if (this.state.isHovering === false) set(this.state, "isHovering", true)
    later(() => {
      if (this.isDestroyed || this.isDestroying) return
      set(this.state, "allowSectionActionAnimation", true)
    }, 30)
  }

  mouseLeave() {
    if (this.hoveringTimer) clearTimeout(this.hoveringTimer)
    this.hoveringTimer = setTimeout(() => {
      if (this.isDestroyed || this.isDestroying) return
      set(this.state, "isHovering", false)
      set(this.state, "allowSectionActionAnimation", false)
    }, 15)
  }

  @action async openStandardsModal() {
    const { standards, standardSetIds } = await this.standardsModal.openStandardsModal(
      this.section.attributes.standards,
      this.store.findInMemory("planbook", this.planbookId),
      // @ts-ignore School::Edit::LessonTemplate doesn't provide a courseId
      this.courseId ? this.store.findInMemory("course", this.courseId) : undefined
    )

    this.lessonEditor.replaceStandards(
      this.modelsNeededForFirstEdit,
      this.cardStackId,
      this.section.id,
      standards,
      standardSetIds,
      this.section.attributes.standards,
      this.planbookId,
      this.courseId,
      this.courseStandardSetIds
    )
  }

  startAiEdits(): void {
    set(this.state, "isAiEditing", true)
    this.set("aiStandards", this.section.attributes.standards)
  }

  setValueFromAi(aiValue: CardStandard[]): void {
    this.set("aiStandards", aiValue)
  }

  acceptAiEdits(): CardStandard[] {
    const result = this.aiStandards
    set(this.state, "isAiEditing", false)
    this.set("aiStandards", [])

    return result
  }

  rejectAiEdits(): void {
    if (!this.state.isAiEditing) return

    set(this.state, "isAiEditing", false)
    this.set("aiStandards", [])
  }
}
